import type { ExtraConfig } from '@gov-nx/core/app/extra-config/context.types';
import { DataBoxFolderType } from '@gov-nx/module/data-box/providers/DataBoxes.types';
import { MySubmissionTabs } from '@gov-nx/module/page/moje-podani/seznam/submissionTabs';
import { getPOKeyValues } from '@gov-nx/module/page/reza/detail/keyValues';

export const extraConfig = (environment: string): ExtraConfig => ({
	application: 'po',
	environment,
	authorization: {
		enabled: true,
	},
	store: {
		persisKey: 'portal-obcana-zustand',
	},
	components: {
		isRezaSwitcherEnabled: true,
		isComplaintMessageVisible: true,
		databoxConnectModal: {
			isConsentCheckboxVisible: true,
		},
	},
	pageRoutes: {
		rezaDetailConfig: {
			rezaDetailContextProvider: {
				keyValues: getPOKeyValues,
			},
			rezaDetail: {
				isHeadlineTagVisible: true,
				isFavoriteToggleVisible: false,
				isHeadlineVisible: true,
				isRozsahVisible: true,
				isSeznamVisible: true,
				isActionsVisible: true,
				isComplaintVisible: true,
				isOverviewFormEnabled: true,
				isInvalidationVisible: true,
				isDownloadButtonVisible: true,
				isSendByDataBoxVisible: true,
			},
		},
		databoxConfig: {
			databoxTransformConfig: {
				deleteOdpojenoIfTrue: false,
			},
			massActionsAllowedFolders: [
				DataBoxFolderType.Sent,
				DataBoxFolderType.Received,
				DataBoxFolderType.Archived,
				DataBoxFolderType.Trash,
			],
			displayArchiveFolder: true,
			displayArchiveAction: true,
			displayBin: true,
			displayAutoArchiveToggle: true,
			displayNotificationPage: true,
			displayConnectedDataboxSettings: true,
			displayArchiveInEmptyFolderState: true,
			displayArchiveOptionsInInitialModal: true,
			displayArchiveTextOnDataboxDisconnect: true,
			displayPopupAfterDataboxConnected: true,
			isSaveToOwnDocumentsAllowed: true,
			isSelectAttachmentsFromOwnFilesRestrictedToPodani: false,
		},
		myFilesConfig: {
			showWithoutFile: true,
			isUploadAllowed: true,
			submitOnClear: false,
		},
		userManualConfig: {
			showMobileManual: true,
		},
		supportConfig: {
			shouldRenderPlaceholders: true,
		},
	},
	serviceRoutes: {
		serviceResolverConfig: {
			hiddenServices: [],
		},
	},
	settingsRoutes: {
		settingsPageConfig: {
			isNotificationsSettingsVisible: true,
			isContactHistoryEnabled: true,
			isNuDataEnabled: true,
		},
	},
	profileRoutes: {
		robConfig: {
			profileRobView: {
				isComplaintCtaVisible: true,
				profileContentLayout: {
					isAccountDeletionLinkVisible: true,
				},
			},
		},
		eDokladyConfig: {
			profileEDocumentsView: {
				profileContentLayout: {
					isAccountDeletionLinkVisible: true,
				},
			},
		},
		rosConfig: {
			profileRosView: {
				isDescriptionVisible: true,
				profileContentLayout: {
					isAccountDeletionLinkVisible: true,
				},
				PFOListView: {
					isDateOfTerminationVisible: false,
					isDateOfCreationVisible: true,
				},
			},
		},
		rosDetailConfig: {
			rosDetail: {
				isComplaintModalVisible: true,
				PODataView: {
					isComplaintCtaVisible: true,
				},
				PFODataView: {
					isComplaintCtaVisible: true,
				},
			},
		},
		certifikatyConfig: {
			profileCertificatesView: {
				profileContentLayout: {
					isAccountDeletionLinkVisible: true,
				},
			},
		},
		dokladyConfig: {
			documentsView: {
				profileContentLayout: {
					isAccountDeletionLinkVisible: true,
				},
			},
		},
		rezaProfileConfig: {
			profileRezaView: {
				profileContentLayout: {
					isAccountDeletionLinkVisible: true,
				},
			},
		},
	},
	submissionsRoutes: {
		routesConfig: {
			[MySubmissionTabs.podani]: {
				isAvailable: true,
			},
			[MySubmissionTabs.osvedceni]: {
				isAvailable: true,
			},
			[MySubmissionTabs.autorizace]: {
				isAvailable: true,
			},
		},
	},
	notificationRoutes: {
		notificationsConfig: {
			enabled: true,
		},
	},
	unauthorizedErrorCodes: [401],
});
